import { MemoryRouter as Router } from 'react-router-dom';
import Login from '../components/Login';
import { WebApp } from '../components/WebApp';
import { WordApp } from '../components/WordApp';
import { useAuthentication } from '../authentication/authProvider';
import OutlookRoutes from '../routes/outlookRoutes';
import AxiosInterceptor from '../api/axiosInterceptor';
import NetworkInterceptor from '../api/networkInterceptor';
import { NavigationProvider } from '../context/NavigationContext';
import { NavigationProvider as NavigationStackProvider } from '../context/NavigationStackContext';
import { ListViewPreferenceProvider } from '../context/ListViewPreferenceContext';
import { Spin } from '../components/Ant';
import { ErrorBoundary } from '@sentry/react';
import ErrorPage from '../components/error/error';
import { ROUTES } from '../constants/constants';
import AuthCallback from '../authentication/authCallback';

const ErrorFallback = ({ resetError }: { resetError: () => void }) => (
  <ErrorPage isException reset={resetError} />
);
export const TaskPane = ({ host }: { host: Office.HostType }) => {
  const { isAuthenticated, isLoading } = useAuthentication();
  const hasForbiddenError = !!sessionStorage.getItem('forbiddenErrorType');

  if (globalThis.location.pathname === ROUTES.TASKPANE_AUTH_REDIRECTION && !isAuthenticated) {
    return <AuthCallback />;
  }

  const getInitialRoute = () => {
    if (hasForbiddenError) {
      return ROUTES.ACCESS_FORBIDDEN;
    }
    return '/';
  };

  const renderApp = (host: Office.HostType) => {
    if (isLoading) {
      return <Spin fullscreen />;
    }

    switch (host) {
      case Office.HostType.Word:
        return <WordApp key="word" />;
      case Office.HostType.Outlook:
        return (
          <Router initialEntries={[getInitialRoute()]}>
            <NavigationStackProvider key="navigation-stack-provider">
              <ListViewPreferenceProvider key="list-view-preference-provider">
                <NavigationProvider key="navigation-provider">
                  <ErrorBoundary fallback={ErrorFallback}>
                    <NetworkInterceptor />
                    <AxiosInterceptor />
                    <OutlookRoutes key="outlook" />
                  </ErrorBoundary>
                </NavigationProvider>
              </ListViewPreferenceProvider>
            </NavigationStackProvider>
          </Router>
        );
      default:
        return <WebApp key="webapp" />;
    }
  };

  // Show login only if not authenticated AND not loading AND no forbidden error
  const shouldShowLogin = !isAuthenticated && !isLoading && !hasForbiddenError;
  return shouldShowLogin ? <Login key="login" /> : renderApp(host);
};
